import type { LDFlagSet } from 'launchdarkly-js-sdk-common';

import {
  FF_C4C_ENABLE_CONNECT_VIDEO_CONSULT,
  FF_C4C_HIDE_PATIENT_PHONE_NUMBER,
  FF_DOC_CONSULT_OUTCOME,
  FF_DOC_CONSULT_TASKS,
  FF_ENABLE_DOCTOR_PROPERTIES,
  FF_ENABLE_DOCTORS_OWN_FOLLOWUP_BUTTON,
  FF_ENABLE_GOOGLE_PLACES_AUTOCOMPLETE,
  FF_ENABLE_PRESCRIPTION_DISPENSE_LIMITS,
  FF_ENABLE_PRESCRIPTION_MANDATORY_MAXIMUM_DAILY_DOSAGES,
  FF_ENABLE_SNOWPLOW,
  FF_ENABLE_WA_NURSE_CONSULT_RESTRICTION,
  FF_ENABLED_OOS_REISSUE_AUTO_ALTERNATIVE,
  FF_FREE_RESCRIPT_ELIGIBILITY,
  FF_INVENTORY_INSIGHTS_ENFORCE_GREENA_REPEATS,
  FF_PAT_ENABLE_DEVICE_PRESCRIPTION,
  FF_PATIENT_ENABLE_OPEN_DOCUMENT_TAB_2026Q1,
  FF_PRESCRIPTION_RECOMMENDED_PRODUCTS_COUNT,
  FF_PRESCRIPTIONS_EXPERIMENT_PAT_PRICING_FILTER,
  FF_REMOVE_UNCHANGED_CONSULT_STATUS_FROM_UPDATE,
  FF_VIEW_CONSULTATION_NOTES_HISTORY,
  FF_WA_ALLOWED_DOCTOR_CODES,
  FF_WA_PATIENT_ALERT,
  FF_WOMBATS_DEVICE_TESTING,
} from '@/constants/featureFlags';

const ffDefaults: LDFlagSet = {
  [FF_ENABLE_SNOWPLOW]: false,
  [FF_PRESCRIPTION_RECOMMENDED_PRODUCTS_COUNT]: 3,
  [FF_PRESCRIPTIONS_EXPERIMENT_PAT_PRICING_FILTER]: false,
  [FF_ENABLED_OOS_REISSUE_AUTO_ALTERNATIVE]: false,
  [FF_ENABLE_DOCTORS_OWN_FOLLOWUP_BUTTON]: false,
  [FF_ENABLE_GOOGLE_PLACES_AUTOCOMPLETE]: false,
  [FF_INVENTORY_INSIGHTS_ENFORCE_GREENA_REPEATS]: false,
  [FF_C4C_ENABLE_CONNECT_VIDEO_CONSULT]: false,
  [FF_PAT_ENABLE_DEVICE_PRESCRIPTION]: false,
  [FF_C4C_HIDE_PATIENT_PHONE_NUMBER]: false,
  [FF_WOMBATS_DEVICE_TESTING]: false,
  [FF_VIEW_CONSULTATION_NOTES_HISTORY]: false,
  [FF_FREE_RESCRIPT_ELIGIBILITY]: false,
  [FF_ENABLE_DOCTOR_PROPERTIES]: false,
  [FF_REMOVE_UNCHANGED_CONSULT_STATUS_FROM_UPDATE]: false,
  [FF_PATIENT_ENABLE_OPEN_DOCUMENT_TAB_2026Q1]: false,
  [FF_DOC_CONSULT_OUTCOME]: false,
  [FF_DOC_CONSULT_TASKS]: false,
  [FF_ENABLE_WA_NURSE_CONSULT_RESTRICTION]: false,
  [FF_WA_ALLOWED_DOCTOR_CODES]: [],
  [FF_WA_PATIENT_ALERT]: false,
  [FF_ENABLE_PRESCRIPTION_DISPENSE_LIMITS]: false,
  [FF_ENABLE_PRESCRIPTION_MANDATORY_MAXIMUM_DAILY_DOSAGES]: false,
};

export default ffDefaults;
